// extracted by mini-css-extract-plugin
export var content = "_nx-1";
export var noScroll = "_nx-3";
export var paper = "_nx-0";
export var scrollable = "_nx-2";